import Vue from "vue";
import store from "./store";
import utils from "./services/utils";

// currency filter plugin in main.js

Vue.filter('acceptableTime', function (minutes) {
  if (!minutes) return '';

  let hours = minutes / 60;

  if (hours < 24) {
    return Math.round( hours * 10 ) / 10 + ' hours';
  }

  return Math.round( (hours / 24) * 10 ) / 10 + ' days';
});

Vue.filter('allCaps', allCaps);
export function allCaps(value) {
  if (!value) return '';
  value = value.toString();
  return value.toUpperCase();
}

Vue.filter('capitalize', capitalize);
export function capitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

Vue.filter('truncate', truncate);
export function truncate(text, length) {
  if (text.length > length) {
    return text.substring(0, length - 3) + '...';
  } else {
    return text;
  }
}


Vue.filter('resolveEnum', resolveEnum);
export function resolveEnum(value, enums) {
  let result = enums[value];
  if (!Array.isArray(enums)) {
    enums = Object.values(enums);
  }
  return enums.find(e => e.value === value);
}

Vue.filter('modelIs', modelIs);
Vue.mixin({methods: {modelIs: modelIs}})

export function modelIs(expectedClassName, model) {
  let className = model.class_name;
  return (className === 'App\\Models\\' + expectedClassName);
}

Vue.filter('modelName', modelName);

export function modelName(model) {
  if (!model || !model.class_name) {
    return '';
  }

  return model.class_name.replace('App\\Models\\', '');
}

Vue.filter('classNameIs', classNameIs);
Vue.mixin({methods: {classNameIs: classNameIs}})
export function classNameIs(value, expectedClassName) {
  return (value === 'App\\Models\\' + expectedClassName);
}

Vue.filter('enumLabel', enumLabel);
Vue.filter('newEnumLabel', utils.newGetEnumLabel);
export function enumLabel(value, enums) {
  if (!enums) {
    return '';
  }

  if (typeof enums === 'string') {
    let enumType = enums;
    enums = store.state.enums[enumType];

    if (!enums) {
      return '';
    }
  }

  return resolveEnum(value, enums).label;
}

Vue.filter('stripTags', utils.stripTags);
Vue.filter('userDisplayName', utils.userDisplayName);

Vue.filter('phone', phone);
export function phone(value) {
  const cleaned = ('' + value).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)

  if (match) {
    const intlCode = (match[1] ? '+1 ' : '')
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }

  return value;
}
